//
//
//
//
//
//
//

export default {
  props: {
    index: {
      type: Number,
      default: 0
    },
    size: { // 二维码尺寸
      type: Number,
      default: 90
    },
    text: { // 二维码内容
      type: String,
      default: ''
    }
  },
  mounted () {
    this.$nextTick(() => {
      const QRCode = window.QRCode
      const t = new QRCode(this.index != 0 ? `qrcode-${this.index}` : 'qrcode', {
        text: this.text,
        width: this.size,
        height: this.size,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.Q
      })
      if (document.getElementById('qrcode')) {
        document.getElementById('qrcode').title = ''
      }
      console.log(t, this.text, 123456)
    })
  },
  methods: {
    test (dataUrl, id) {
    }
  }
}
